import BaseColors from '@/atoms/colors/Base';
import EntityColors from '@/atoms/colors/Entity';
import EntityType from '@enums/EntityType';
import { core } from '@/lib/theme/tokens/color';
import { brand } from '@/lib/theme/tokens/palettes';

const BadgeColor = Object.freeze({
  primary: {
    backgroundColor: brand.yellow.main,
    color: BaseColors.font.tertiary,
  },
  secondary: {
    backgroundColor: BaseColors.font.tertiary,
    color: core.white,
  },
  tertiary: {
    backgroundColor: brand.lightBlue.main,
    color: BaseColors.font.tertiary,
  },
  [EntityType.ACTIVITY]: {
    backgroundColor: EntityColors[EntityType.ACTIVITY].primary,
    color: core.white,
  },
  [EntityType.GROUP]: {
    backgroundColor: EntityColors[EntityType.GROUP].primary,
    color: core.white,
  },
  [EntityType.MANAGER]: {
    backgroundColor: EntityColors[EntityType.MANAGER].primary,
    color: core.white,
  },
  [EntityType.PERSON]: {
    backgroundColor: EntityColors[EntityType.PERSON].color.tints[5],
    color: core.white,
  },
  [EntityType.ROLE]: {
    backgroundColor: EntityColors[EntityType.ROLE].primary,
    color: core.white,
  },
});

export default BadgeColor;
